import type { ImgHTMLAttributes } from "react";

export function Image(props: ImgHTMLAttributes<HTMLImageElement>) {
  return <img loading="lazy" alt={props.alt} {...props} />;
}

export default Image;
